import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const ErrorIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.79294 7.79289C7.40242 8.18342 7.40242 8.81658 7.79294 9.20711L10.6214 12.0355L7.79289 14.864C7.40237 15.2545 7.40237 15.8877 7.79289 16.2782C8.18342 16.6687 8.81658 16.6687 9.20711 16.2782L12.0356 13.4497L14.864 16.2782C15.2545 16.6687 15.8877 16.6687 16.2782 16.2782C16.6688 15.8877 16.6688 15.2545 16.2782 14.864L13.4498 12.0355L16.2782 9.20714C16.6687 8.81661 16.6687 8.18345 16.2782 7.79292C15.8877 7.4024 15.2545 7.4024 14.864 7.79292L12.0356 10.6213L9.20716 7.79289C8.81663 7.40237 8.18347 7.40237 7.79294 7.79289Z"
      fill="currentColor"
    />
  </Icon>
);
